import produce from 'immer';
import { ActionType } from '../action-types';
import { Action } from '../actions';
import { initialStates } from '../initial-states/initialStates';
import { BillsState } from '../initial-states/stateTypes';

const initialState = initialStates.bills.normalState;

const reducer = produce((state: BillsState = initialState, action: Action) => {
  switch (action.type) {
    case ActionType.UPDATE_RPU:
      state.rpu = action.payload;
      return state;
    case ActionType.ADD_RPU_TO_REQUESTED_BILLS:
      state.requestedBills.unshift(action.payload);
      return state;
    case ActionType.UPDATE_MASS_UPLOAD_FILE:
      state.massUploadFile = action.payload;
      return state;
    case ActionType.UPDATE_MASS_UPLOAD_RPU_LIST:
      state.massUploadRPUList = action.payload;
      return state;
    default:
      return state;
  }
}, initialState);

export default reducer;
